import { config } from './config.js';
export function isLocale(s) {
    return s in config;
}
export function isAvailableInContext(s, context) {
    return config[s].availableIn.includes(context);
}
//# sourceMappingURL=utils.js.map